<template>
    <div id="page" class="page-content">
        <div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
        <div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
        <div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>

        <div class="page-title-small color-white bottom-30">
            <h1><i class="fa fa-arrow-left back-button"></i>Recibo Conformidad OT {{ idcotizacionvehiculo }}</h1>
            <a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark"
                v-bind:style="userimageurl"></a>
        </div>

        <div class="content-boxed">

            <div class="content bottom-0">
                <iframe class="caption caption-margins round-medium shadow-large" width="98%" height="600px"
                    :src="getIframeSrc()" frameborder="0"></iframe>


                <form onsubmit="event.preventDefault();" class="contactForm" id="FormsubmitFecha">
                    <table width='100%' class="bg-gray1-dark">
                        <tr>
                            <td width='100%' class="row bg-gray1-dark" style="text-align: left; display: flex; justify-content: center; align-items: center;">
                                <div style="padding-left: 20px; width: 50%; display: flex; display: flex; justify-content: center;">
                                    <div class="form-field form-name" style="text-align:left; width: 100%;">
                                        <label class="color-theme">Fecha entrega:<span>(requerida)</span></label>
                                        <input id="fechaentregaot"  type="datetime-local"
                                            class="round-small">
                                    </div>
                                </div>
                                <div style="padding-left: 20px; padding-right: 20px; width: 50%; display: flex; justify-content: center;">
                                    <div class="form-field form-name" style="text-align:left; width: 100%;">
                                        <label class="color-theme">Kilometraje Salida:<span>(requerida)</span></label>
                                        <input id="Kilometraje" 
                                                type="number" 
                                                v-model="KilometrajeSalida" 
                                                class="round-small" 
                                                min="0" 
                                                step="1" 
                                                oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="row bg-gray1-dark" style="display: flex ; justify-content: center;">
                                <div style="text-align: right">
                                    <VueSignaturePad id="signature" width="513px" height="100px" ref="signaturePad" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td width='20%' class="row bg-gray1-dark">
                                <div class="col-3 mt-2">
                                    <button @click="undoimage"
                                        class="button button-s shadow-small button-circle bg-dark1-dark">
                                        <i class="fa fa-times"></i>
                                        Limpiar firma
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </table>
                </form>

                <div class="contact-form">
                    <form onsubmit="event.preventDefault();" class="contactForm" id="Formsubmit">
                        <div class="content-boxed">
                            <a href="#"
                                class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton"
                                @click="siguiente(idcotizacionvehiculo, idExterno)" data-formId="dataForm">Siguiente</a>
                        </div>
                    </form>
                </div>

            </div>

        </div>

    </div>
</template>

<style>
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image:url(./../../assets/images/firmaClienteReciboConformidad.png),
  linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-size:100% 100%;
  background-origin: border-box;
  background-clip: content-box, border-box;
  background-repeat: no-repeat;
}
</style>

<script>
    import * as db from "../../database.js";
    import * as validate from "../../validate.js";

    import VueSignaturePad from 'vue-signature-pad';

    export default{
        data(){
            return{
                params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculoReciboConformidad')+'","tablename":"T_VEH_COTIZACIONVEHICULO"}',
                idcotizacionvehiculo: localStorage.getItem('idcotizacionvehiculoReciboConformidad'),
                idExterno: localStorage.getItem('idExternoReciboConformidad'),
                KilometrajeSalida: null,

                OT:{
                    codvehiculo:0,
                    marca:"",
                    modelo:"",
                    version:"",
                    agno:"",
                    placapatente:"",
                    vin:"",

                    kilometraje:0,
                    datatipoot:"",
                    datatipotrabajo:"",
                    fechaentrega:"",
                    horaentrega:"" ,  
                    fechaentregaotasesor:"", 
                    KilometrajeSalida:0
                }
            }
        },

        created(){
            this.userimageurl="background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")" 
        },

        mounted(){
            let strSql;

            strSql="SELECT IN_KILOMETRAJEVEHICULO_COTIZACIONVEHICULO kilometraje,"
			+"V.IN_COD_VEHICULO codvehiculo,"
            +"COT.IN_KILOMETRAJESALIDAVEHICULO_COTIZACIONVEHICULO KilometrajeSalida,"
			+"DT_FECHAENTREGAOT_COTIZACIONVEHICULO fechaentregaot,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,120) fechaentrega,"
			+"CONVERT(VARCHAR(10),DT_FECHAENTREGAOT_COTIZACIONVEHICULO,108) horaentrega,"
			+"COT.IN_ESORDENTRABAJOINTERNA_COTIZACIONVEHICULO datatipoot,"
			+"COT.IN_COD_TIPOTRABAJO datatipotrabajo,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL1_VEHICULO) marca,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL2_VEHICULO) modelo,"
			+"(SELECT ST_DESC_DETALLECLASIFICACION D FROM T_GEN_DETALLECLASIFICACION D WHERE IN_COD_DETALLECLASIFICACION=V.IN_VALORNIVEL3_VEHICULO) version,"
			+"IN_AGNOFABRICACION_VEHICULO agno,ST_PLACAPATENTE_VEHICULO placapatente,ST_NVIN_VEHICULO vin,"
            +"DT_FECHAENTREGAOTASESOR_COTIZACIONVEHICULO fechaentregaotasesor"
			+" FROM T_VEH_COTIZACIONVEHICULO COT,T_VEH_VEHICULO V"
			+" WHERE COT.IN_COD_COTIZACIONVEHICULO="+this.idcotizacionvehiculo
			+" AND COT.IN_COD_VEHICULO=V.IN_COD_VEHICULO"

            db.getQuery(strSql)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
                this.OT=result.data.data
                var Kilometraje = this.OT.KilometrajeSalida;

                if(Kilometraje != null){
                    this.KilometrajeSalida = Kilometraje;
                }else{
                    this.KilometrajeSalida = 0
                }
            }}); 
        },

        computed: {
            formattedFechaEntregaOT() {
                // Verificar si fechaentregaotasesor está vacío
                if (this.OT.fechaentregaot) {
                    return this.OT.fechaentregaot.slice(0, 16);
                } else {
                    return '';
                }
            }
        },

        methods:{
            undoimage() 
            {
                this.$refs.signaturePad.clearSignature();
            },

            undo() 
            {
                alert('undo');
                this.$refs.signaturePad.undoSignature();
            },

            getIframeSrc() {

                var url = db.getServerHTTP();

                if (url == "https://puente.xxi.cl/") {
                    url = "https://xxi.netcar.cl/taller/tlrShowOTReciboconformidad.aspx?id=" + this.idExterno;
                }

                if (url == "https://puente.valenzueladelarze.cl/") {
                    url = "http://vyd.netcar.cl/taller/tlrShowOTReciboconformidad.aspx?id=" + this.idExterno;
                }

                if (url == ("https://preproduccionxxi.netcar.cl/")){
                    url = db.getServerHTTP() + "resources/_netcarsiglo21com/taller/tlrShowOTReciboconformidad.aspx?id=" + this.idExterno;
                }


                return url;
            },

            siguiente(idcotizacionvehiculo, idExterno)
            {
                const FechaEntrega = document.getElementById("fechaentregaot").value;

                if(!FechaEntrega){
                    alert("Debe ingresar una fecha de entrega antes de continuar.");
                    return;
                }

                this.paramsvehiculo='{"valkey":"'+this.OT.codvehiculo+'","tablename":"T_VEH_VEHICULO"}';

                db.envioFechaAsesor(FormsubmitFecha,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err); console.log(result)}else{
                    
                    const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                    if(data!=null)
                    {
                        console.log(data);
                        db.getFx2("ot.saveimageFirmReciboConformidad",'{"idcotizacionvehiculo":"'+ this.idcotizacionvehiculo+'","data":"'+ data+'"}').then(result => {
                            
                            const respuesta = Array.isArray(result) ? result[0] : result;

                            if (respuesta.data.err!="")
                            {
                                alert(result.data.err);
                                console.log (result.data.err);
                            }
                            else
                            {
                                const paginaAnterior = localStorage.getItem("PaginaVolver") || "/MisOT";
                                window.location = paginaAnterior 
                            }
                        });
                    }else{
                        const paginaAnterior = localStorage.getItem("PaginaVolver") || "/MisOT";
                        window.location = paginaAnterior 
                    }
                }});
                
            }
        }
    }

</script>